import { IVector2 } from '@easytwin/runtime';
import classNames from 'classnames';
import React from 'react';

interface GridProps {
  highlightClassName?: string;
  unhighlightClassName?: string;
  x: number;
  y: number;
  selectedPos: IVector2;
  onClick?: (pos: IVector2) => void;
}

export function Grid(props: GridProps) {
  const { highlightClassName, unhighlightClassName, x, y, selectedPos, onClick } = props;

  const highlight = selectedPos.x === x && selectedPos.y === y;
  return (
    <div
      className={classNames(
        'bg-bgColor232324 cursor-pointer rounded-sm',
        highlight
          ? 'w-3 h-3 border-2 border-primary bg-white'
          : 'w-[10px] h-[10px] border border-FFFFFF1F',
        highlight ? highlightClassName : unhighlightClassName,
      )}
      onClick={() => {
        onClick?.({ x, y });
      }}
    />
  );
}
